module.exports = __webpack_public_path__ + "img/Síndico-Profissional-Remuneração.b4a3b533.jpg";